import { render, staticRenderFns } from "./InteractionCardPanel.vue?vue&type=template&id=3f6447a2&scoped=true"
import script from "./InteractionCardPanel.vue?vue&type=script&lang=js"
export * from "./InteractionCardPanel.vue?vue&type=script&lang=js"
import style0 from "./InteractionCardPanel.vue?vue&type=style&index=0&id=3f6447a2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f6447a2",
  null
  
)

export default component.exports